import { render, staticRenderFns } from "./Form_2.vue?vue&type=template&id=76ecb3a9&scoped=true"
import script from "./Form_2.vue?vue&type=script&lang=js"
export * from "./Form_2.vue?vue&type=script&lang=js"
import style0 from "./Form_2.vue?vue&type=style&index=0&id=76ecb3a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ecb3a9",
  null
  
)

export default component.exports